<div class="practice_place">

  <span class="sub_title">
    <fa-icon [icon]="getFaIcon('faMapMarkerAlt')" appChangeColorTheme attribute="color"></fa-icon>
    Lieu(x) de pratique
  </span>
  
  <div class="edit_element">
    <fa-icon [icon]="getFaIcon('faInfoCircle')" (click)="openDialogShowListing(practicePlace, 'PracticePlace')" [matTooltip]="getTooltip('clubDetailsStructure')" appChangeColorTheme attribute="color"> </fa-icon>
    <fa-icon [icon]="getFaIcon('faPen')" [routerLink]="['/admin/practice-place']" [queryParams]="{clubCode: clubCode}" routerLinkActive="router-link-active" appChangeColorTheme attribute="color" > </fa-icon>
  </div>

  <p *ngIf="!practicePlace?.length ">{{userConnected.role === 'admin' ? 'Il n\'y a aucun lieu de pratique': 'Vous n\avez aucun lieu de pratique'}}</p>
  <p *ngIf="practicePlace?.length ">Il y a <strong>{{practicePlace?.length}}</strong> {{practicePlace?.length > 1 ? 'lieux' : 'lieu'}} de pratique</p>

</div>